import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from 'store/store';
import { logEditState } from './logEditState';
import { LogEditsState } from '../types';

export const logEditSlice = createSlice({
  name: 'logEdits',
  initialState: logEditState,
  reducers: {
    setDataReset(state) {
      return {
        ...state,
        ...logEditState,
      };
    },
    setSortBy(state, action: PayloadAction<LogEditsState['sortBy']>) {
      state.sortBy = action.payload;
    },
    setSortField(state, action: PayloadAction<LogEditsState['sortField']>) {
      state.sortField = action.payload;
    },
    setLogEdits(state, action: PayloadAction<LogEditsState['logEdits']>) {
      state.logEdits = action.payload;
    },
    setLogEditsReportData(
      state,
      action: PayloadAction<LogEditsState['logEditsReportData']>,
    ) {
      state.logEditsReportData = action.payload;
    },
    setDriver(state, action: PayloadAction<LogEditsState['driver']>) {
      state.driver = action.payload;
    },
    setLogStatus(state, action: PayloadAction<LogEditsState['logStatus']>) {
      state.logStatus = action.payload;
    },
    setTerminal(state, action: PayloadAction<LogEditsState['terminal']>) {
      state.terminal = action.payload;
    },
    setDateRange(state, action: PayloadAction<LogEditsState['dateRange']>) {
      state.dateRange = action.payload;
    },
    setFilterByDriverId(
      state,
      action: PayloadAction<LogEditsState['isFilterByDriverId']>,
    ) {
      state.isFilterByDriverId = action.payload;
    },
    setRowsPerPage(state, action: PayloadAction<LogEditsState['limit']>) {
      state.limit = action.payload;
    },
    setPageIndex(state, action: PayloadAction<LogEditsState['offset']>) {
      state.offset = action.payload;
    },
    setTotalRecordCounts(
      state,
      action: PayloadAction<LogEditsState['totalRecordCount']>,
    ) {
      state.totalRecordCount = action.payload;
    },
    setDocumentType(
      state,
      action: PayloadAction<LogEditsState['documentType']>,
    ) {
      state.documentType = action.payload;
    },
    setPaperOrientation(
      state,
      action: PayloadAction<LogEditsState['paperOrientation']>,
    ) {
      state.paperOrientation = action.payload;
    },
    setRequestPendingTo(
      state,
      action: PayloadAction<LogEditsState['isRequestPending']>,
    ) {
      state.isRequestPending = action.payload;
    },
    setToggleExportFileModal(
      state,
      action: PayloadAction<LogEditsState['isToggleExportFileModal']>,
    ) {
      state.isToggleExportFileModal = action.payload;
    },
    setExportDataRequestPendingTo(
      state,
      action: PayloadAction<LogEditsState['isExportDataRequestPending']>,
    ) {
      state.isExportDataRequestPending = action.payload;
    },
  },
});

/* ------- ACTION CREATORS ------- */
export const { actions: logEditActions } = logEditSlice;

/* ------- STATE SELECTORS ------- */
export const selectLogEdits = (state: RootState) => state.logEdits;

export default logEditSlice.reducer;
